export function clampDay(year: number, month: number, day: number): number {
  const lastDay = new Date(year, month + 1, 0).getDate();
  return Math.min(day, lastDay);
}
export function addMonthsSafe(base: Date, months: number): Date {
  const y = base.getFullYear();
  const m = base.getMonth();
  const d = base.getDate();
  const ny = y + Math.floor((m + months) / 12);
  const nm = (m + months) % 12;
  const nd = clampDay(ny, nm, d);
  return new Date(
    ny,
    nm,
    nd,
    base.getHours(),
    base.getMinutes(),
    base.getSeconds()
  );
}
export function addYearsSafe(base: Date, years: number): Date {
  const y = base.getFullYear() + years;
  const m = base.getMonth();
  const d = clampDay(y, m, base.getDate());
  return new Date(
    y,
    m,
    d,
    base.getHours(),
    base.getMinutes(),
    base.getSeconds()
  );
}
